import React from 'react'
import { withTranslation } from "react-i18next";
import InsLoader from 'components/InsLoader/InsLoader';

const Loading = ({t}) => {
  return (
    <div className='max-w'>
        {<InsLoader classes='relative lds-spinner'/>}
        <p className='text mt'>{t('Please wait...')}</p>
        <p className='text'>{t('We are checking your data.')}</p>
    </div>
  )
}

export default withTranslation()(Loading)